
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logo-website-squarespace",
      function () {
        return require("private-next-pages/logo-website-squarespace.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logo-website-squarespace"])
      });
    }
  